"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = exports.preconfigs = void 0;
var preconfigs_1 = require("./../config/preconfigs");
exports.preconfigs = {
    appearance: "both",
    palette: {
        extend: "trust",
    },
    border: "light",
    padding: "larger",
    radius: "smoothest",
    background: "light",
    shadow: {
        size: "md",
        opacity: 4,
    },
};
var defaultConfig = function (preconfigs) {
    var components = {
        accordion: {
            rounded: preconfigs_1.radius[preconfigs.radius].accordion,
            softBg: preconfigs_1.background[preconfigs.background].accordion.soft,
            ghostBg: preconfigs_1.background[preconfigs.background].accordion.ghost,
            shadow: preconfigs.shadow,
            dark: {
                softBg: preconfigs_1.background[preconfigs.background].dark.accordion.soft,
                ghostBg: preconfigs_1.background[preconfigs.background].dark.accordion.ghost,
                elevatedBg: preconfigs_1.background[preconfigs.background].dark.accordion.elevated,
            },
        },
        alert: {
            rounded: preconfigs_1.radius[preconfigs.radius].alert,
            shadow: preconfigs.shadow,
        },
        annonce: {
            rounded: preconfigs_1.radius[preconfigs.radius].annonce,
        },
        avatar: {
            rounded: preconfigs_1.radius[preconfigs.radius].avatar,
            statusInset: "px",
        },
        badge: {
            rounded: preconfigs_1.radius[preconfigs.radius].badge,
        },
        button: {
            rounded: preconfigs_1.radius[preconfigs.radius].button,
            borderWith: "1.5",
        },
        card: {
            rounded: preconfigs_1.radius[preconfigs.radius].card,
            padding: preconfigs_1.padding[preconfigs.padding].card,
            bg: preconfigs_1.background[preconfigs.background].card,
            shadow: preconfigs.shadow,
            dark: {
                bg: preconfigs_1.background[preconfigs.background].dark.card,
            },
        },
        ui: {
            borderColor: preconfigs_1.borderColors[preconfigs.border].ui,
            hoverBorderColor: preconfigs_1.borderColors[preconfigs.border].hover,
            dark: {
                borderColor: preconfigs_1.borderColors[preconfigs.border].dark.ui,
                hoverBorderColor: preconfigs_1.borderColors[preconfigs.border].dark.hover,
            },
        },
        menu: {
            rounded: preconfigs_1.radius[preconfigs.radius].menu,
            borderColor: preconfigs_1.borderColors[preconfigs.border].menu,
            bgOpacity: 80,
            backdropBlur: "3",
            shadow: preconfigs.shadow,
            dark: {
                bg: preconfigs_1.background[preconfigs.background].dark.menu,
                borderColor: preconfigs_1.borderColors[preconfigs.border].dark.menu,
                bgOpacity: 50,
                backdropBlur: "5",
            },
        },
        feedback: {
            borderColor: preconfigs_1.borderColors[preconfigs.border].feedback,
            shadow: preconfigs.shadow,
            dark: {
                borderColor: preconfigs_1.borderColors[preconfigs.border].dark.feedback,
                bg: preconfigs_1.background[preconfigs.background].dark.feedback,
            },
        },
        flag: {
            rounded: preconfigs_1.radius[preconfigs.radius].flag,
            padding: preconfigs_1.padding[preconfigs.padding].flag,
        },
        field: {
            rounded: preconfigs_1.radius[preconfigs.radius].field,
            softBg: preconfigs_1.background[preconfigs.background].field,
            softBgFocus: preconfigs_1.background[preconfigs.background].fieldFocus,
            borderColor: preconfigs_1.borderColors[preconfigs.border].field,
            dark: {
                softBg: preconfigs_1.background[preconfigs.background].dark.field,
                softBgFocus: preconfigs_1.background[preconfigs.background].dark.fieldFocus,
                borderColor: preconfigs_1.borderColors[preconfigs.border].dark.field,
            },
        },
        popover: {
            rounded: preconfigs_1.radius[preconfigs.radius].popover,
            padding: preconfigs_1.padding[preconfigs.padding].popover,
        },
        switch: {
            rounded: preconfigs_1.radius[preconfigs.radius].switch,
        },
        toast: {
            rounded: preconfigs_1.radius[preconfigs.radius].toast,
        },
        tooltip: {
            rounded: preconfigs_1.radius[preconfigs.radius].tooltip,
        },
        tabs: {
            rounded: {
                list: preconfigs_1.radius[preconfigs.radius].tabs.default,
                softVariant: preconfigs_1.radius[preconfigs.radius].tabs.soft,
                bottomIndicatorVariant: preconfigs_1.radius[preconfigs.radius].tabs.bottomIndicator,
            },
            listBg: preconfigs_1.background[preconfigs.background].tabs,
            borderColor: preconfigs_1.borderColors[preconfigs.border].tabs,
            dark: {
                listBg: preconfigs_1.background[preconfigs.background].dark.tabs.list,
                triggerBg: preconfigs_1.background[preconfigs.background].dark.tabs.trigger,
                indicatorBg: preconfigs_1.background[preconfigs.background].dark.tabs.indicator,
                borderColor: preconfigs_1.borderColors[preconfigs.border].dark.tabs,
            },
        },
        select: {
            dark: {
                bg: preconfigs_1.background[preconfigs.background].dark.select,
            },
        },
    };
    return components;
};
exports.defaultConfig = defaultConfig;
exports.default = exports.defaultConfig;
